import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import {
    logErrorFromClientSdk,
    trackBusinessError,
    logInfoMessage,
} from '@sxm-de/dev-kits/web-sdk/utils';

interface LoginWithPasswordFnPayload {
    handle: string;
    password: string;
}

export type LoginWithPasswordFn = (
    payload: LoginWithPasswordFnPayload,
) => Promise<unknown>;

export function initLoginWithPasswordFn({
    dependencies,
}: DomainInitPayload): LoginWithPasswordFn {
    const { appEventSdk, clientSdk } = dependencies;
    return async (payload: LoginWithPasswordFnPayload) => {
        try {
            logInfoMessage(
                `Login with password. Handle: ${payload?.handle}`,
                dependencies,
            );
            await clientSdk.user.anonymousLogin(true);
            await clientSdk.user.login(payload);
        } catch (error: any) {
            if (error.code === 'userServices.identity.invalidCredentials') {
                trackBusinessError(appEventSdk, error);
                throw new Error('INVALID_CREDENTIALS');
            } else {
                logErrorFromClientSdk(error, dependencies);
                throw new Error('SYSTEM');
            }
        }
    };
}
